import {
  ADD_ADDRESS,
  REPLACE_ADDRESS,
  SET_ADDRESS,
  SET_USER_VISIBLE_COLUMNS
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_ADDRESS](state, addresses) {
    state.addresses = addresses;
  },
  [ADD_ADDRESS](state, address) {
    state.addresses = [address, ...state.addresses];
  },
  [REPLACE_ADDRESS](state, address) {
    let index = state.addresses.findIndex(wh => wh.id === address.id);
    if (index >= 0) {
      state.addresses.splice(index, 1, address);
    }
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  }
};